import { useCallback } from "react";
import LoyaltyOffer from "../../../utils/LoyaltyOfferClass/LoyaltyOffer";
import { selectRedeemedLineSubItemIds } from "../../redux/selectors/loyaltyCartSelectors";
import { selectRedeemedLoyaltyOffer } from "../../redux/selectors/loyaltyOfferSelectors";
import { useAppSelector } from "../useReduxHooks";

/**
 * Instance-aware "is this offer card active" check for split milestone offers.
 *
 * Split instances repeat the same offer id — one card per item choice — so
 * `offer.isEqual(redeemed)` alone marks every choice as applied. An
 * item-specific instance is active only when its target sub-item is among the
 * cart lines the redemption actually added. Non-item-specific instances (and
 * the window between redeem and item selection, when no line exists yet) fall
 * back to plain offer equality.
 */
export function useIsLoyaltyOfferInstanceActive(): (
  offer: LoyaltyOffer
) => boolean {
  const redeemedLoyaltyOffer = useAppSelector(selectRedeemedLoyaltyOffer);
  const redeemedLineSubItemIds = useAppSelector(selectRedeemedLineSubItemIds);

  return useCallback(
    (offer: LoyaltyOffer) => {
      if (!offer.isEqual(redeemedLoyaltyOffer)) {
        return false;
      }

      const targetEntityId = offer.getSingleTargetItemEntityId();
      if (!targetEntityId || redeemedLineSubItemIds.length === 0) {
        return true;
      }

      return redeemedLineSubItemIds.includes(targetEntityId);
    },
    [redeemedLoyaltyOffer, redeemedLineSubItemIds]
  );
}
